<template>
    <v-main class="pa-2" fluid>
        <v-row>
            <v-btn @click="dialog = true" color="primary" dark>Add Agent</v-btn>
            
                <v-dialog v-model="dialog" @keydown.esc="dialog = false" persistent max-width="600px">
                    <v-card color="lighten-1">
                        <v-toolbar>
                            <v-toolbar-title>
                                <span class="headline">{{formTitle}}</span>
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-form ref="form" v-model="valid" class="row">
                                        <v-col cols="12" md="12">

                                            <v-text-field label="Name" v-model="editedItem.name" :rules="nameRules" required></v-text-field>
                                              
                                            <p>Save the name exactly as it appears in bookeo, so the system can match the new bookings coming in. Example:</p>
                                                <ul>
                                                    <li>Viator <strong>is different of</strong> VIATOR</li>
                                                    <li>kkday <strong>is different of</strong> Kkday</li>
                                                </ul>
                                        </v-col>        
                                        <v-col cols="12" md="12">
                                            <fieldset class="inline-form">
                                          <v-text-field
                                                                          v-model="editedItem.phone"
                                                                          label="Phone Number"
                                                                          
                                                                        ></v-text-field>
                                          
                                                                        <v-text-field
                                                                          v-model="editedItem.email"
                                                                          :rules="emailRules"
                                                                          label="E-mail"
                                                                          
                                                                        ></v-text-field>
                                        </fieldset>
                                        </v-col>
                          
                    
                    
                                        <v-col cols="12" md="12">
                    
                                        <fieldset class="inline-form">
                                            <v-checkbox
                                             v-model="editedItem.prepaid" label="Prepaid Booking" :value="1" />
                                                
                                                <v-text-field class="short" label="Commission" v-model="editedItem.commission" type="number"
                                                ></v-text-field>
                                        </fieldset>
                    
                                        </v-col>
                    
                                    </v-form>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                            <v-btn color="blue darken-1" type="submit" @click="save" :disabled="!valid">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            
        </v-row>

        <v-data-table
            :headers="headers"
            :items="agents"
            :items-per-page="10"
            class="elevation-1">
                 <template v-slot:item.actions="{ item }">

                <v-btn icon small @click="edit(item)">
                  <v-icon center>mdi-pencil</v-icon> 
                </v-btn>

                <v-btn icon small color="red" @click="deleteAgent(item.id)">
                  <v-icon center>mdi-delete-forever</v-icon> 
                </v-btn>

                </template>

                <template v-slot:item.prepaid="{ item }">
                    <span v-if="item.prepaid">Yes</span>
                </template>
            </v-data-table>
    </v-main>
</template>

<style>.short { max-width: 8em }</style>

<script>
    import { mapState } from 'vuex'

    export default {
        data() {
            return {
                headers: [
                    { text: '', value: 'data-table-expand' },
                    { text: 'Name', align: 'start', sortable: true, value: 'name', },
                    { text: 'Email', align: 'start', sortable: true, value: 'email', },
                    { text: 'Phone', align: 'start', sortable: true, value: 'spots', },
                    { text: 'Prepaid', align: 'start', sortable: true, value: 'prepaid', },
                    { text: 'Commission', align: 'start', sortable: true, value: 'commission', },
                    { text: '', align: 'start', sortable: false, value: 'actions', },
                ],

                dialog: false,
                editedIndex: -1,
                valid: true,
                lazy: true,
                isEditing: null,
                editedItem: {
                    name: '',
                    email: '',
                    prepaid : false,
                    phone : null,
                    commission : 0,
                },
                nameRules: [
                    v => !!v || 'Name is required',
                ],
                emailRules: [
                        v => !!v || 'E-mail is required',
                        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                ],
            }
        },

        mounted () {
            this.$store.dispatch('fetchAgents')
        },


        computed: {
            ...mapState(['agents']),


            formTitle () {
                return this.editedIndex === -1 ? 'New Agent' : 'Edit Agent'
            },
        },

        watch: {
            dialog (val) {
                val || this.close()
            },
        },
        
        methods: {

            edit(item) { 

                this.editedIndex = this.agents.indexOf(item);
                this.editedItem = Object.assign({}, item)

                this.dialog = true
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                  this.editedItem = Object.assign({}, this.defaultItem)
                  this.editedIndex = -1
                  
                })
              },


              save () {

                if (this.editedIndex > -1) {


                    this.editedItem.commission = parseInt(this.editedItem.commission)

                    axios.put('/api/agents/' + this.editedItem.id, this.editedItem)
                        .then( response => {

                            Object.assign(this.agents[this.editedIndex], this.editedItem)
                            this.close();
                            
                        })
                        .catch( err => {
                            console.log( err )
                        })

                  
                } else {


                    axios.post('/api/agents', this.editedItem)
                    .then( response => {

                        this.agents.push(this.editedItem)

                        this.close();
                        
                    })
                    .catch( err => {
                        console.log( err )
                    })
                  
                }

              },

              deleteAgent(id) {
                confirm('Are you sure you want to delete this Agent? This action can not be undone') && 

                axios.delete('/api/agents/' + id)
                        .then( response => {

                            const index = this.agents.map(function (f) { return f.id }).indexOf(id)

                            this.$store.state.agents.splice(index, 1)
                        })
                        .catch( err => {
                            console.log( err )
                        })
              }
          }
    }
</script>